import React, { createContext, useContext } from 'react';
export var ExecutionContextRoot = /*#__PURE__*/createContext(null);
export var useExecutionContext = function useExecutionContext() {
  var executionContext = useContext(ExecutionContextRoot);
  if (executionContext === null) {
    throw new Error('executionContext value is null');
  }
  return executionContext;
};
export var ExecutionContextProvider = function ExecutionContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  if (!value) {
    throw new Error('ExecutionContextProvider requires a value');
  }
  return /*#__PURE__*/React.createElement(ExecutionContextRoot.Provider, {
    value: value
  }, children);
};